<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
        />
      </v-col>

      <!-- <v-col cols="4">
        <v-text-field
          v-model="entry.code"
          v-bind="getObject('code')"
          label="Código"
        />
      </v-col> -->

      <v-col cols="12">
         <v-text-field
          v-model="selectedChartOfAccountName"
          v-bind="getObject('parentId')"
          label="Plano de Contas Pai"
          @click="clickChartOfAccount"
          clearable
          @click:clear="clearChartOfAccountParent"
          ref="textFieldChartOfAccountRef"
          class="enabledTextFieldChartOfAccount"
          inputmode="none"
        />
      </v-col>

      <ChartOfAccountSelect
        newTitle="Selecionar Plano de Contas Pai"
        width="50%"
        newSaveButtonLabel="Confirmar"
        @select-confirm-action="chartOfAccountSelected"
        ref="chartOfAccountSelectRef"
        :loadActiveChartOfAccount="entry.parent"
        :unableToSelectParentNodes="false"
        :key="chartOfAccountSelectKey"
      />

    </v-row>
  </v-form>
</template>

<script>
// import MaskedTextField from "@shared_components/masked_text_field.vue"
import ChartOfAccountSelect from "@models/chart_of_accounts/select.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      selectedChartOfAccountName: null,
      chartOfAccountSelectKey: 1,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    ChartOfAccountSelect: ChartOfAccountSelect,
    BaseUtil: BaseUtil,
    // MaskedTextField: MaskedTextField,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

  if (this.entry.parent) {
    this.selectedChartOfAccountName = this.entry.parent.text;
  }
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    clickChartOfAccount: function() {
      this.$refs.chartOfAccountSelectRef.openDialog();
      this.$refs.textFieldChartOfAccountRef.blur();
    },
    chartOfAccountSelected: function(val) {
      // console.log(val);
      this.entry.parent = val;
      this.entry.parentId = val.id;
      this.selectedChartOfAccountName = val.text;
    },
    clearChartOfAccountParent: function() {
      this.selectedChartOfAccountName = null;
      this.entry.parent = null;
      this.entry.parentId = null;
      this.chartOfAccountSelectKey++;
    }
  }
};
</script>

<style scoped>
  ::v-deep .enabledTextFieldChartOfAccount input {
    cursor: pointer;
  }
</style>
